import { render, staticRenderFns } from "./welcome-tcr.vue?vue&type=template&id=2816bf20&scoped=true&"
import script from "./welcome-tcr.vue?vue&type=script&lang=js&"
export * from "./welcome-tcr.vue?vue&type=script&lang=js&"
import style0 from "./welcome-tcr.vue?vue&type=style&index=0&id=2816bf20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2816bf20",
  null
  
)

export default component.exports